import { IMember, INewUser } from "@wingspanhq/users/dist/lib/interfaces";

import { getProfileDataAddress } from "../FormPartialAddress";

import { emptyValues } from "./emptyValues";

import { FormPartialDataPerson, FormPartialPersonType } from ".";

export function getProfileDataPerson(
  type: FormPartialPersonType,
  user?: INewUser,
  member?: IMember
): Partial<FormPartialDataPerson> {
  if (type === "BeneficialOwner") {
    return {};
  }

  const profileAddress = getProfileDataAddress(member, {
    homeAddress: type === "Representative"
  });

  return {
    address: { ...emptyValues.address, ...profileAddress },
    birthday: user?.profile.dob,
    country: member?.profile.address?.country || "US",
    firstName: user?.profile.firstName,
    lastName: user?.profile.lastName,
    middleName: user?.profile.middleName
  };
}
